import {
  removeFolder,
  removeMessage,
  setWorkflowStep,
} from "../../store/reducers/root";
import prepareMessage from "../prepareMessage";
import { sleep } from "telegram/Helpers";
import * as Sentry from "@sentry/react";

export default async function sendMessageNow(
  client,
  folder,
  dispatch,
  setShowSuccessAlert,
  setShowErrorAlert,
  setLoading,
  message,
) {
  await client.connect();
  await client.getDialogs({
    folderId: folder.value,
    limit: 1000,
  });

  const errors = {
    CHAT_WRITE_FORBIDDEN: 0,
    CHAT_ADMIN_REQUIRED: 0,
    OTHERS: 0,
    CHATS_WITH_ERRORS: [],
  };

  client.setParseMode("html");

  const formattedMessage = await prepareMessage(client, folder, message);
  let index = 0;
  let success = 0;
  let result = false;
  let linkToTg;
  for (const channel of folder.channels) {
    try {
      console.debug("sent message to entity", index, " - ", channel.peerId);
      result = await client.sendMessage(channel.peerId, {
        message: formattedMessage[index],
        // clearDraft: true
      });
      await sleep(16);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e.message.startsWith("403")) {
        errors.CHAT_WRITE_FORBIDDEN++;
      } else if (e.message.startsWith("400")) {
        errors.CHAT_ADMIN_REQUIRED++;
      } else {
        errors.OTHERS++;
      }
      errors.CHATS_WITH_ERRORS.push(channel);
      result = false;
    }

    if (result) {
      success++;
      linkToTg = channel.tgLink;
    }
    index++;
  }

  console.debug(errors);
  if (success !== 0) {
    dispatch(setWorkflowStep(0));
    dispatch(removeFolder());
    dispatch(removeMessage());
    return linkToTg;
  } else {
    return false;
  }
}
